import isDark from '../utils/isDark';
export default function textContrastClass(hexcolor) {
  if (!hexcolor) return 'text-contrast--unchanged';
  return isDark(hexcolor) ? 'text-contrast--light' : 'text-contrast--dark';
}
flarum.reg.add('core', 'common/helpers/textContrastClass', textContrastClass);